export default "__VITE_ASSET__IPoFiWtj__"